import React from 'react';

function Post() {
    return <p>This is a post</p>
}

export default Post;